<app-dialog-container
  title="{{ (isLibrary ? 'cloneFormLibrary' : 'cloneForm') | translate }}"
  confirmButtonText="{{ 'copy' | translate }}"
  [isValid]="!!tenant.value"
  (confirmButtonHandler)="copy()"
>
  <app-ui-select
    label="{{ 'selectTenant' | translate }}"
    [control]="tenant"
    [options]="tenants()"
    [required]="true"
    [isMultiple]="false"
    (changeHandler)="onTenantChange()"
  ></app-ui-select>

  @if (tenant.value && !isLibrary) {
    <app-ui-select
      label="{{ 'selectFormLibrary' | translate }}"
      [control]="library"
      [options]="getFormsLibraries()"
      [required]="false"
      [isMultiple]="false"
    ></app-ui-select>
  }
</app-dialog-container>
